import React from "react";

import VeneerList from "veneer/List";
import VeneerListItem from "veneer/ListItem";

interface ListProps {
  items: string[];
}

function List({ items }: ListProps) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <VeneerList disablePadding listStyleType="disc">
      {items.map((idx) => (
        <VeneerListItem disablePadding key={idx}>
          {idx}
        </VeneerListItem>
      ))}
    </VeneerList>
  );
}

export { List };
export default List;
